import { FC } from 'react';
import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { IComment } from '../../shared/interfaces/IComment';
import Helper from '../../shared/helpers/Helper';
import { IReviewDateFormat } from '../../shared/interfaces/IReviewNew';

interface Props {
  companyComment: IComment;
  sx?: SxProps<Theme>;
  dateFormat?: IReviewDateFormat;
}

const Comment: FC<Props> = ({ companyComment, sx, dateFormat }) => {
  const theme = useTheme();

  const { position, date, name, comment } = companyComment;

  function formatDate(timestamp: string | null | undefined, short: boolean) {
    console.log('formatting date', timestamp, dateFormat);
    if (!dateFormat?.comment) {
      return Helper.getFormattedDate(timestamp, short);
    }
    return Helper.getCustomFormattedDate(timestamp, dateFormat.comment);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        p: theme.spacing(2),
        borderRadius: `${theme.shape.borderRadius}px`,
        ...sx,
      }}
    >
      <Typography variant="body1">{name}</Typography>
      {position && (
        <Typography
          variant="caption"
          sx={{ color: theme.palette.text.secondary }}
        >
          {position}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{ mb: theme.spacing(1), color: theme.palette.text.secondary }}
      >
        {formatDate(date, true)}
      </Typography>
      {comment && (
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {comment}
        </Typography>
      )}
    </Box>
  );
};

export default Comment;
